<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
<div class="login__wrapper">
  <div class="login">
    <div
      v-if="infoMessage"
      class="row"
    >
      <div class="col-12">
        <div class="alert" :class="`alert-${infoMessageType}`">
          {{ infoMessage }}
        </div>
      </div>
    </div>
    <div class="row gy-3">
      <div class="col-12">
        <input
          v-model="userAppId"
          placeholder="App ID"
          type="text"
          class="form-input"
        >
      </div>
      <div class="d-grid">
        <button
          :disabled="isClickedbtnLogin"
          class="btn btn-outline-primary btn-block"
          @click="handleSendLogin"
        >
          <span v-if="!isClickedbtnLogin">{{ $t('login.btn_enter') }}</span>
          <pre-loader v-else/>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 prev-text" v-html="$t('login.header_message')" />
    </div>
  </div>
</div>
</template>
<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import Login from '@/components/mixins/methodsLogin';
import userMethods from '@/components/mixins/methodsUser';

export default {
  name: 'LoginView',
  props: ['locale'],
  mixins: [appBaseNav, Login, userMethods],
  data() {
    return {
      exId: 1,
      appId: null,

      infoMessage: null,
      infoMessageType: 'info',
      isClickedbtnLogin: false,
    };
  },
  computed: {
    userAppId: {
      get() {
        return this.appId;
      },
      set(value) {
        this.appId = value;
      },
    },
  },
  watch: {
    locale() {
      this.$store.commit('setPageTitle', this.$t('login.header_title'));
    },
  },
  created() {
    // Сообщение оставляет тот, кто сюда увёл, — например экран быстрой
    // авторизации. Пока оно есть, автоматический уход с логина запрещён:
    // иначе со старым токеном человек уедет на дашборд, не прочитав причину.
    const infoMessage = this.$store.getters.getInfoMessages;
    if (infoMessage) {
      this.infoMessage = infoMessage.text;
      this.infoMessageType = infoMessage.type || 'info';
    }

    try {
      if (!infoMessage && this.$store.getters.isAuth) {
        this.pushToLastUrl();
      }
    } catch (e) {
      console.error(e);
    }
  },
  // Чистим по уходу с маршрута, а не в beforeUnmount: App.vue держит
  // router-view на appLoaded и во время загрузки конфига пересоздаёт экран,
  // а сообщение должно пережить это пересоздание.
  beforeRouteLeave() {
    this.$store.commit('clearInfoMessage');
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('login.header_title'));
    // TODO
    this.$store.commit('setProgressVal', 0);
  },
  methods: {
    handleSendLogin() {
      this.isClickedbtnLogin = true;
      this.sendLogin({
        app_id: this.appId,
      })
        // eslint-disable-next-line consistent-return
        .then((data) => {
          if (data?.token) {
            this.$store.commit('setToken', data.token);
            localStorage.setItem('token', data.token);

            return this.getUserProfile();
          }
          if (data?.message) {
            return { message: data.message };
          }
          return { message: this.$t('system.net_unavailable') };
        })
        .then((data) => {
          if (data.message) {
            this.infoMessage = data.message;
          }
          if (data.id) {
            this.$store.commit('setUserID', data.id || null);
            this.$store.commit('setUserRole', data.role || null);
            // Отмеченное гостем уезжает на сервер фоном: переход этого не ждёт.
            this.handoffProgramFavorite();
            this.pushToLastUrl();
          }
        })
        .finally(() => {
          this.isClickedbtnLogin = false;
        });
    },
    pushToLastUrl() {
      const { name, params } = this.$store.getters.getLastUrl || {};
      if (name) {
        this.$router.push({ name, params });
      } else {
        this.$router.push({ name: 'DashboardView' });
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/style/variables.scss';
.prev-text {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
  a {
    text-decoration: none;
  }
  p {
    margin: 0;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    height: 52px;
  }
  // «Получить билет» у Интерткани залита акцентом, а не обведена им:
  // это единственное действие на экране входа для того, у кого ещё нет AppID.
  .btn-success {
    border-color: $color-accent-legacy;
    background-color: $color-accent-legacy;
    color: #FEFEFE;

    &:hover, &:focus, &:active {
      background-color: #FEFEFE;
      color: $color-accent-legacy;
    }
  }
  .btn-large {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    padding: 0 25px;
    border-radius: 25px;
    text-align: center;
    font-weight: 700;
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.login {
  width: 100%;
  max-width: 450px;
  &__wrapper {
    display: flex;
    align-items: start;
    justify-content: center;
    height: 100%;
    padding: 16px;
    overflow: hidden auto;

    @media (min-height: 650px) {
      align-items: center;
    }
  }
  .form-input {
    width: 100%;
    height: 52px;
    padding: 0 12px;
    border: 1px solid #1c1c1c;
    border-radius: 16px;
    background: #FEFEFE;
  }
  .btn {
    height: 52px;
    border-radius: 16px;

    & .preloader__wrapper {
      transform: scale(.5);
    }
  }
  .btn-outline-primary {
    border-color: #e62d86;
    color: #e62d86;
    // &:focus {
    //   background: #FEFEFE;
    //   color: #356899;
    // }
    &:hover, &:focus, &:active {
      // background: #356899;
      // color: #FEFEFE;
      background: #e62d86;
      color: #ffffff;
    }
  }
}
</style>
